import React from "react"
import {
  addressItem,
  addressesFullsizeContainer,
  carnetAdresseResponsiveOnly,
} from "../carnet-adresse.module.scss"
import PropTypes from "prop-types"
import AddressContent from "../AddressContent/address-content"
import MultiCarousel from "react-multi-carousel"
import {
  carouselArrowRight,
  carouselArrowLeft,
} from "../../../Transformers/CarouselTransformer/carousel-transformer.module.scss"
import { CustomArrows } from "../../Carousel/custom-arrow-styled"

const RenderAddresses = ({ addressesData }) => {
  const addresses = addressesData.allNodeCarnetDAdresse.edges
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }
  return (
    <>
      <div className={addressesFullsizeContainer}>
        {addresses.map(({ node }) => (
          <div key={node.drupal_id} className={addressItem}>
            <AddressContent address={node} />
          </div>
        ))}
      </div>
      <MultiCarousel
        className={carnetAdresseResponsiveOnly}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={false}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
      >
        {addresses.map(({ node }) => {
          return (
            <div key={node.drupal_id} className={addressItem}>
              <AddressContent address={node} />
            </div>
          )
        })}
      </MultiCarousel>
    </>
  )
}

const CustomRightArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows
      className={carouselArrowRight}
      style={{
        left: "calc(18% + 1px) !important",
      }}
      onClick={() => onClick()}
    />
  )
}
const CustomLeftArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows className={carouselArrowLeft} onClick={() => onClick()} />
  )
}

RenderAddresses.propTypes = {
  addressesData: PropTypes.object.isRequired,
}
CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
}
CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
}

export default RenderAddresses
